var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#D7F1DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.144 43.68-6.883-6.878a1.978 1.978 0 0 0-3.225 2.153c.099.24.245.458.428.642l8.291 8.284a1.976 1.976 0 0 0 2.797 0l20.985-20.97a1.975 1.975 0 0 0-1.399-3.373c-.524 0-1.027.208-1.398.579L30.144 43.679z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingBubble);
export default __webpack_public_path__ + "static/media/onboarding-bubble.e015d285d31969cea0972024cb43a39e.svg";
export { ForwardRef as ReactComponent };